export default __webpack_public_path__ + "static/media/menu_my_profile_okara.4aa3c7e0.svg";